<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <slot name="search" />
      <el-form
        ref="ff"
        size="small"
        :inline="true"
        :model="queryParams"
        class="search-form"
      >
        <el-form-item>
          <el-input
            v-model="queryParams.keyWord"
            clearable
            :placeholder="
              queryParams.keyType == 1
                ? '询价编码/标题/客户'
                : '负责人/业务员/投标人'
            "
          >
            <el-select
              v-model="queryParams.keyType"
              slot="prepend"
              placeholder="请选择"
              style="width: 100px"
            >
              <el-option label="询价信息" :value="1"></el-option>
              <el-option label="人员信息" :value="2"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>

    <!--表格-->
    <el-table :data="datalist.Items" height="100%" @expand-change="onExpand">
      <el-table-column type="expand">
        <div slot-scope="{ row }" class="detail">
          <el-descriptions :column="1">
            <el-descriptions-item label="询价目录">{{
              row.Columns
            }}</el-descriptions-item>
            <el-descriptions-item label="商务要求" v-if="row.Demands">
              <el-popover
                trigger="click"
                placement="right"
                popper-class="popcss"
              >
                <el-link slot="reference" type="primary" :underline="false"
                  >查看</el-link
                >
                {{ row.Demands }}
              </el-popover>
            </el-descriptions-item>
            <el-descriptions-item label="报价时间"
              >{{ row.BeginDate }} 至 {{ row.ExpiryDate }}</el-descriptions-item
            >
            <el-descriptions-item label="联系方式"
              >{{ row.Linkman }} - {{ row.Linktel }}</el-descriptions-item
            >
            <el-descriptions-item label="送货地址">{{
              row.Address
            }}</el-descriptions-item>
            <el-descriptions-item label="投标备注" v-if="row.BidRemarks">{{
              row.BidRemarks
            }}</el-descriptions-item>
            <el-descriptions-item label="相关文件" v-if="row.Files">
              <el-link
                v-for="item in row.Files"
                :key="item.id"
                type="primary"
                :href="item.url"
                target="_blank"
                >{{ item.name }}</el-link
              >
            </el-descriptions-item>
            <el-descriptions-item label="出库单号" v-if="row.OutboundArray">
              <el-link
                type="primary"
                v-action="'/api/ProductManage/Outbound/GetList'"
                v-for="(item, index) in row.OutboundArray"
                :key="index"
                @click="
                  $router.push({
                    name: '75fb079e57e1424996cc1a899d623270',
                    params: { order: item },
                  })
                "
                >{{ item }}</el-link
              >
            </el-descriptions-item>
          </el-descriptions>
          <el-scrollbar>
            <el-timeline :reverse="true">
              <el-timeline-item v-for="(item, index) in row.Logs" :key="index">
                <label class="describe"
                  >【{{ item.Operator }} 于 {{ item.CreateTime }}】</label
                >
                <label>{{ item.Remarks }}</label>
              </el-timeline-item>
            </el-timeline>
          </el-scrollbar>
        </div>
      </el-table-column>
      <el-table-column prop="Mode.Text" label="询价类别" width="80" />
      <el-table-column prop="Code" label="询价单号" width="160">
        <template slot-scope="{ row }">
          <el-link
            v-if="row.Mode.Code == 'zxxj'"
            type="primary"
            :href="
              'https://zxxj.zcygov.cn/bidding/detail?type=BIDDING_INVITATION&requisitionId=' +
              row.Code
            "
            target="_blank"
            >{{ row.Code }}</el-link
          >
          <el-link
            v-else-if="row.Mode.Code == 'fxjj'"
            type="primary"
            :href="
              'https://fxjj.zcygov.cn/bidding/detail?type=BIDDING_INVITATION&requisitionId=' +
              row.Code
            "
            target="_blank"
            >{{ row.Code }}</el-link
          >
          <el-link
            v-else-if="row.Mode.Code == 'jbxx'"
            type="primary"
            :href="
              'https://inquiryhall.zcygov.cn/inquiryhall/detail?inquiryId=' +
              row.Code
            "
            target="_blank"
            >{{ row.Code }}</el-link
          >
          <template v-else>{{ row.Code }}</template>
        </template>
      </el-table-column>
      <el-table-column
        prop="Title"
        label="询价标题"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column
        prop="Customer"
        label="客户信息"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column label="控制总价" min-width="100">
        <el-tooltip
          slot-scope="{ row }"
          placement="right"
          :disabled="!row.FinalPrice"
        >
          <label slot="content">成交价￥{{ row.FinalPrice }}</label>
          <label class="text-price text-danger">{{ row.BudgetPrice }}</label>
        </el-tooltip>
      </el-table-column>
      <el-table-column label="截止时间" min-width="100">
        <template slot-scope="{ row }">
          <span
            v-if="row.Surplus > 0 && row.Surplus < 24"
            style="color: #f56c6c"
            >剩余{{ row.Surplus }}小时</span
          >
          <span v-else>{{
            $utils.common.parseTime(row.ExpiryDate, "{m}/{d} {h}:{i}")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Dept.Name"
        label="责任部门"
        min-width="100"
        show-overflow-tooltip
      />
      <el-table-column
        prop="Director.Name"
        label="负责人"
        min-width="80"
        align="center"
      />
      <el-table-column
        prop="Executor.Name"
        label="业务员"
        min-width="80"
        align="center"
      />
      <el-table-column
        prop="Bidder.Name"
        label="投标人"
        min-width="80"
        align="center"
      />

      <el-table-column label="报价" min-width="100">
        <label
          slot-scope="{ row }"
          class="text-price text-danger"
          v-if="row.BidPrice"
          >{{ row.BidPrice }}</label
        >
      </el-table-column>
      <el-table-column label="操作" width="110">
        <template slot-scope="{ row }">
          <slot name="column" :data="row" />
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      slot="footer"
      background
      :page-size="datalist.PageSize"
      :current-page="datalist.PageIndex"
      :total="datalist.TotalCount"
      @current-change="onPager"
    />
  </full-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      datalist: {},
      queryParams: {},
    };
  },
  props: {
    state: { type: Number, default: null },
    result: { type: Number, default: null },
    expired: { type: Boolean, default: null },
  },
  created() {
    this.resetForm();
  },
  methods: {
    // 查询参数
    onSearch() {
      this.queryParams.index = 1;
      this.loadData();
    },
    resetForm() {
      this.queryParams = {
        index: 1,
        size: 20,
        state: this.state,
        result: this.result,
        expired: this.expired,
        keyType: 1,
      };
      this.loadData();
    },
    // 分页触发事件
    onPager(val) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      this.loading = true;
      this.$apis.project.inquiry
        .list(this.queryParams)
        .then((res) => {
          res.Items.map((row) => {
            this.$set(row, "Files", null);
            this.$set(row, "Logs", null);
          });
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onExpand(row) {
      //加载附件
      if (!row.Files) {
        this.$apis.system.file
          .list({
            objectId: row.Id,
          })
          .then((res) => {
            this.$set(row, "Files", res || []);
          });
      }
      //加载日志
      if (!row.Logs) {
        this.$apis.project.inquiry.logs({ id: row.Id }).then((res) => {
          this.$set(row, "Logs", res || []);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  :deep(.el-descriptions__body) {
    .el-descriptions-row:hover {
      background-color: unset !important;
    }
    .el-descriptions-item {
      border: unset !important;
      padding: 5px 10px;
      &__label {
        min-width: 80px;
        color: #99a9bf;
      }
    }
  }
  .el-scrollbar {
    max-height: 250px;
  }
  :deep(.el-timeline) {
    &-item {
      padding: 5px 0;
    }
  }
}
.describe {
  span + span {
    margin-left: 10px;
  }
  .el-link {
    font-size: 10px;
    margin-left: 10px;
  }
}
</style>